import React from 'react'
import { Route } from 'react-router-dom'
import { UserRole, UserRoles } from '../types/userRoles'
import ProtectedRoute from '../routes/ProtectedRoute'
import DeactivatedUserRoute from '../routes/DeactivatedUserRoute'
import { MenuItem } from '../types/menuItem.types'
import { Route as RouteConfig } from '../types/route.types'
import GlobalPageWrapper from '../components/GlobalPageWrapper/GloblaPageWrapper'

export const generateProtectedRoutes = (routes: RouteConfig[], allowedRole: UserRole, menuItems: MenuItem[]) => {
  return routes
    .map((route) => {
      // Use DeactivatedUserRoute for member routes to handle deactivated users
      const RouteComponent = allowedRole === UserRoles.MEMBER ? DeactivatedUserRoute : ProtectedRoute

      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <GlobalPageWrapper menuItems={menuItems}>
              <RouteComponent allowedRole={allowedRole}>{route.element as React.ReactElement}</RouteComponent>
            </GlobalPageWrapper>
          }
        />
      )
    })
    .filter(Boolean) // Remove null values from the array
}
